import React, {PureComponent, useEffect, useRef, useState} from 'react';
import { useAuthContext } from '../../../contexts/AuthContext';
import { AgendaRequest, AgendaShift, AgendaUser, GetAgendaRequestQuery, GetAgendaRequestQueryVariables, GetAgendaShiftQuery, GetAgendaShiftQueryVariables, GetAgendaUserQuery, GetAgendaUserQueryVariables, ModelSortDirection, RequestsByComIdQuery, RequestsByComIdQueryVariables, RequestsBySuggestedUserQuery, RequestsBySuggestedUserQueryVariables, RequestsByUserQuery, RequestsByUserQueryVariables, ShiftsByComIdQuery, ShiftsByComIdQueryVariables, ShiftsByUserQuery, ShiftsByUserQueryVariables, UpdateAgendaRequestMutation, UpdateAgendaRequestMutationVariables, UpdateAgendaShiftMutation, UpdateAgendaShiftMutationVariables, UsersByComIdQuery, UsersByComIdQueryVariables } from '../../../graphql/API';
import { getAgendaShift, getAgendaUser, getAgendaRequest, updateAgendaRequest, updateAgendaShift, requestsByComId, requestsByUser, requestsBySuggestedUser } from '../queries';
import { useLazyQuery, useMutation, useQuery } from '@apollo/client';
import { Button, Col, Container, Modal, Nav, Row, Spinner, Stack, Tab, Tabs } from 'react-bootstrap';
import { Link, NavLink, useNavigate, useParams, useLocation } from 'react-router-dom';
import { IoArrowRedoCircleOutline } from 'react-icons/io5';
import { useTranslation } from 'react-i18next';
import { format } from 'date-fns';
import { enUS, fr } from 'date-fns/locale';
import Cookies from 'js-cookie';
import CustomModal from '../../../components/Modals/CustomModal';
import UserImage from '../../../components/UserImage';
import { MdSwapHorizontalCircle } from "react-icons/md";
import Sidebar from '../../services/Sidebar/Sidebar';
import TopicNotificationService from '../../services/TopicService/TopicNotificationService';
import { Pagination } from '@aws-amplify/ui-react';
import { FaBorderTopLeft } from 'react-icons/fa6';
import useDateService from '../../services/DateService';
import { useNotification } from '../../../contexts/NotificationProvider';
import useNotificationStorageService from '../../services/NotificationStorageService';
import { REQUESTS_PER_PAGE } from '../../../config';
import { Toast, ToastContainer } from 'react-bootstrap';

const RequestSuggestedUserLeavesScreen = () => {
  // AUTH
  const {userId: AuthUserId} = useAuthContext();
  // I18N
  const { t } = useTranslation();
  const savedLang = Cookies.get('language');
  // PARAMS
  const { id } = useParams<{ id: string }>();
  // NAVIGATION
  const location = useLocation();
  const navigate = useNavigate();
  // TOAST
  const [showToast, setShowToast] = useState(false);
  const [toastStatus, setToastStatus] = useState("");
  const [toastTitle, setToastTitle] = useState("");
  const [toastMessage, setToastMessage] = useState("");
  // MODAL
  const [contentModal, setContentModal] = useState(null);
  const [linkModal, setLinkModal] = useState(null);
  const [showCustomModal, setShowCustomModal] = useState(false);
  const [footerModal, setFooterModal] = useState(true);
  // NOTIFICATION
  const {sendTopicNotification} = TopicNotificationService();
  const notificationContext = useNotification();
  const notificationCount = notificationContext?.notificationCount;
  const setNotificationCount = notificationContext?.setNotificationCount;
  const leaveRequestCount = notificationContext?.leaveRequestCount;
  const setLeaveRequestCount = notificationContext?.setLeaveRequestCount;
  const {updateNotificationModelCount} = useNotificationStorageService();
  // DATE SERVICES
  const {getTIMEZONE} = useDateService();
  // HOME SETTINGS
  const TIMEZONE = getTIMEZONE();
  // PAGINATION
  const [pageTokens, setPageTokens] = React.useState([null]);
  const [totalPagination, setTotalPagination] = React.useState(1);
  const [currentPageIndex, setCurrentPageIndex] = React.useState(1);
  const [hasMorePages, setHasMorePages] = React.useState(true);
  const [dontUpdateAnymore, setDontUpdateAnymore] = useState(false);
  const [requestsState, setRequestsState] = useState([]);
  // TABS  
  // const [key, setKey] = useState('accueil');

  const {data: dataUser, loading: loadingUser, error: errorUser, refetch: refetchUser, fetchMore: fetchMoreUser} = useQuery
    <GetAgendaUserQuery, GetAgendaUserQueryVariables>(getAgendaUser,
      {variables: {userId: AuthUserId}});

  // const [ fetchSuggestedUser, {data: dataSuggestedUser, loading: loadingSuggestedUser, error: errorSuggestedUser, refetch: refetchSuggestedUser, fetchMore: fetchMoreSuggestedUser}] = useLazyQuery
  //   <GetAgendaUserQuery, GetAgendaUserQueryVariables>(getAgendaUser);

  const [ fetchRequests, {data: dataRequests, loading: loadingRequests, error: errorRequests, refetch: refetchRequests, fetchMore: fetchMoreRequests}] = useLazyQuery
    <RequestsBySuggestedUserQuery, RequestsBySuggestedUserQueryVariables>(requestsBySuggestedUser);

  const [doUpdateShift] = useMutation<UpdateAgendaShiftMutation, UpdateAgendaShiftMutationVariables>(updateAgendaShift);
  const [doUpdateRequest] = useMutation<UpdateAgendaRequestMutation, UpdateAgendaRequestMutationVariables>(updateAgendaRequest);
    
  const user = dataUser?.getAgendaUser;
  const requests = dataRequests?.requestsBySuggestedUser?.items || [];

  useEffect(() => {
    if (location.state?.toastMessage) {
      setToastStatus(location.state.status);
      setToastTitle(location.state.title);
      setToastMessage(location.state.toastMessage);
      setShowToast(true);

      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location.state]);

  const getRequests = async (token: string) => { //date: Date, 
    if (user?.comId) {
      return await fetchRequests({
        variables: {
          suggestedUser: user.userId,
          limit: REQUESTS_PER_PAGE,
          nextToken: token,
          sortDirection: ModelSortDirection.DESC,
          filter: {
            type: {eq: "leave"},
            deleted: {ne: true}
          }
        }});
    }
  }

  useEffect(() => {
      setNotificationCount && setNotificationCount((notificationCount ?? 0) - (leaveRequestCount ?? 0));
      updateNotificationModelCount('leaveRequest', 0);
      setLeaveRequestCount && setLeaveRequestCount(0);
  }, [location]);

  useEffect(() => {
    if (!user) return;
    if (!user.comId) return;
    getRequests(pageTokens[pageTokens.length - 1]);
    refetchRequests(); // hack to get the refresh (need to modify in the futur POSSIBLY WITH useLocation)
  }, [user]);

  useEffect(() => {
      if (dataRequests && dataRequests.requestsBySuggestedUser && !dontUpdateAnymore) {
        const newRequests = dataRequests.requestsBySuggestedUser.items;
        const newToken = dataRequests.requestsBySuggestedUser.nextToken;
   
        setRequestsState(newRequests); // Met à jour la liste des utilisateurs
        if (newToken) {
          setPageTokens((prevTokens) => [...prevTokens, newToken]); // Ajoute un nouveau token
          setHasMorePages(true);
        } else {
          setHasMorePages(false); // Pas de token suivant, fin de la pagination
        }
      }
    }, [dataRequests]);
  
    useEffect(() => {
      if (hasMorePages) {
        setTotalPagination(pageTokens.length);
      } else {
        setTotalPagination(pageTokens.length - 1);
      }
    },[hasMorePages]);
  
    const handlePageChange = async (pageIndex: any) => {
      setDontUpdateAnymore(true);
      setCurrentPageIndex(pageIndex);
  
      const selectedToken = pageTokens[pageIndex - 1]; // Récupérer le token de la page sélectionnée
      if (selectedToken !== undefined) {
        const { data: { requestsBySuggestedUser: { items: newRequests, nextToken: newNextToken } } } = await getRequests(selectedToken);
  
        if (newRequests.length !== 0) {
          setRequestsState(newRequests);
          REQUESTS_PER_PAGE > 1 ? setTotalPagination(pageTokens.length) : setTotalPagination(pageTokens.length - 1);
          if (newNextToken && !pageTokens.includes(newNextToken)) {
            setPageTokens((prevTokens) => [...prevTokens, newNextToken]);
          }
          // console.log(pageTokens);
        } else {
          if (hasMorePages) {
            setHasMorePages(false);
          }
        }
      }
    };
  
    const handleNextPage = async () => {
      setDontUpdateAnymore(true);
      // if (hasMorePages) {
        // const nextToken = pageTokens[pageTokens.length - 1]; // Dernier token actuel
        const nextToken = pageTokens[currentPageIndex];
  
        if (nextToken) {
          const { data: { requestsBySuggestedUser: { items: newRequests, nextToken: newNextToken } } } = await getRequests(nextToken);
  
          if (newNextToken) {
            setRequestsState(newRequests);
            REQUESTS_PER_PAGE > 1 ? setTotalPagination(pageTokens.length) : setTotalPagination(pageTokens.length - 1);
            // console.log('allo');
            if (!pageTokens.includes(newNextToken)) {
                setPageTokens((prevTokens) => [...prevTokens, newNextToken]); // Ajoute le nouveau token
            }
            setCurrentPageIndex(currentPageIndex + 1);
          } else {
            if (newRequests.length > 0) {
              setRequestsState(newRequests);
              REQUESTS_PER_PAGE > 1 ? setTotalPagination(pageTokens.length) : setTotalPagination(pageTokens.length - 1);
              setCurrentPageIndex(currentPageIndex + 1);
              // removeLastPagination();
              setHasMorePages(false);
            } else {
              if (hasMorePages) {
                // removeLastPagination();
                setHasMorePages(false);
              }
            }
            // setHasMorePages(false); // Si pas de nextToken, on désactive la pagination
          }
          // console.log(pageTokens);
  
          // setCurrentPageIndex(currentPageIndex + 1); // Mise à jour de l'index de la page
        } else {
          console.error("Next token is undefined or null");
        }
      // }
    };
  
  const handlePreviousPage = async () => {
    if (currentPageIndex > 1) {
      const prevToken = pageTokens[currentPageIndex - 2];
      const { data: { requestsBySuggestedUser: { items: prevRequests, nextToken: newNextToken } } } = await getRequests(prevToken);

      setRequestsState(prevRequests);
      // setPageTokens(pageTokens.slice(0, -1)); 
      // if (hasMorePages) {
      //  setHasMorePages(nextToken ? true : false);
      // }
      REQUESTS_PER_PAGE > 1 ? setTotalPagination(pageTokens.length) : setTotalPagination(pageTokens.length - 1);
      setCurrentPageIndex(currentPageIndex - 1);
    }
  };

  // console.log(dataShifts?.shiftsByUser);
  if (!requests || !user ) {
    return (
        <div className="spinnerContainer">
            {/* <Spinner animation="border" role="status" style={styles.spinner as React.CSSProperties}> */}
            <Spinner animation="border" role="status" className="spinner">
                <span className="visually-hidden">Loading...</span>
            </Spinner>   
        </div>
    )
  };

  const getLanguage = () => {
    switch (savedLang) {
      case 'en':
        return enUS
      case 'fr':
        return fr
      default:
        return enUS
    }
  }

  const truncate = (str: string | undefined, maxlength: number) => {
    if (str) {
      return (str.length > maxlength) ?
      str.slice(0, maxlength - 1) + '…' : str;
    } else {
      return str;
    }
  };

  // const transferShift = async (request: AgendaRequest) => {
  //   setShowCustomModal(false);
  //   if (!user || !user.type) return;
  //   if (user.type === "MANAGER") {
  //     try {
  //         await doUpdateShift({
  //           variables: {
  //             input: {
  //               shiftId: request.shiftId,
  //               userId: request.suggestedUser,
  //               username: request.suggestedUserUsername,
  //             },
  //           },
  //         });
  //     } catch(error) {
  //         alert("Error on Shift Acceptation: " + error);
  //     };
  //     try {
  //         await doUpdateRequest({
  //           variables: {
  //             input: {
  //               requestId:request.requestId,
  //               completed: true,
  //             //   // @ts-ignore
  //             //   _version: shift?._version || 1, // Provide a default value or ensure _version exists
  //             },
  //           },
  //         });
  //         await sendTopicNotification(request.shift.role, request.shift.location ?? undefined, /*request.suggestedUser.FCMtoken ??*/ undefined, request.suggestedUser ?? undefined, request.shiftId, request.shift.startAt, request.shift.stopAt, request.shift.confirmed ? "confirmShift" : "shift");
  //         refetchRequests();
  //     } catch(error) {
  //         alert("Error on Shift Acceptation: " + error);
  //     };
  //   } else {
  //     alert("Error on Shift Tranfer: " + "You don't have the credential to update this shift");
  //   }
  // };

  // const swapShift = (request: AgendaRequest) => {
  //   setFooterModal(false);
  //   setContentModal(<>
  //     <Modal.Header closeButton>
  //       <Modal.Title>{t('shift.areYouSure')}</Modal.Title>
  //         </Modal.Header>
    
  //         <Modal.Body>
  //           <p>{t('request.swapMessage')}{request.suggestedUserUsername} ?</p></Modal.Body>
  //         <Modal.Footer>
  //           <Button variant="secondary" onClick={() => setShowCustomModal(false)}>
  //             {t('shift.cancel')}
  //           </Button>
  //           <Button variant="primary" onClick={ () => transferShift(request)}>
  //             {t('request.transfer')}
  //           </Button>
  //         </Modal.Footer>
  //     </>);
  //   setShowCustomModal(true);
  // } 

  // const alreadySwaped = () => {
  //   setContentModal(<>
  //     <Modal.Header closeButton>
  //       <Modal.Title>{t('title.request')}</Modal.Title>
  //     </Modal.Header>

  //     <Modal.Body>
  //       <p>{t('request.alreadySwaped')}</p>
  //     </Modal.Body>
  //     </>);
  //   setShowCustomModal(true);
  // } 
  
  return (
    <>
    <CustomModal
        show={showCustomModal}
        onHide={() => setShowCustomModal(false)}
        link={linkModal}
        children={contentModal}
        isFooter={footerModal}
        // animation={true}
      />

      <ToastContainer className="p-3 toastTop">
          <Toast onClose={() => setShowToast(false)} show={showToast} delay={3000} autohide className={`${toastStatus}`}>
              { toastTitle != "" &&
              <Toast.Header className={`text-center ${toastStatus}`}>
                  <strong className="mx-auto text-white-50  ">{toastTitle}</strong>
              </Toast.Header>
              }
              <Toast.Body className="text-center"><strong className="mx-auto text-white text-center">{toastMessage}</strong></Toast.Body>
          </Toast>
      </ToastContainer>

      <div className="d-flex">
        <Sidebar user={user} />
        <div className="users-container flex-grow-1 p-3">
          <div className="users-container">
            {/* TABS INTERNE */}
            {/* <Container className="mt-4">
              <Tabs
                id="tab-navigation"
                activeKey={key}
                onSelect={(k) => setKey(k)}
                className="mb-3"
                justify
              >
                <Tab eventKey="accueil" title="Accueil">
                  <div>Bienvenue sur la page d’accueil 🎉</div>
                </Tab>
                <Tab eventKey="profil" title="Profil">
                  <div>Voici votre profil utilisateur 👤</div>
                </Tab>
              </Tabs>
            </Container> */}
            { user.type === "MANAGER" ?
              <Nav variant="tabs" activeKey={location.pathname} className="nav-fill w-100 justify-content-center" style={{borderBottom: 0}}>
                <Nav.Item>
                  <Nav.Link as={NavLink} to={t('link.leave_create')} eventKey={t('link.leave_create')} style={{textDecoration: 'none', fontWeight: 'bold', color: '#11947e', borderBottom: 0}}>
                    {t('request.createLeaveTab')}
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link as={NavLink} to={t('link.requests_leave')} eventKey={t('link.requests_leave')} style={{textDecoration: 'none', fontWeight: 'bold', color: '#BBB', backgroundColor: '#f5f5f5', borderBottom: 0}}>
                    {t('request.leaveTab')}
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link as={NavLink} to={t('link.leave_management')} eventKey={t('link.leave_management')} style={{textDecoration: 'none', fontWeight: 'bold', color: '#11947e', borderBottom: 0}}>
                    {t('request.managerLeaveTab')}
                  </Nav.Link>
                </Nav.Item>
              </Nav>
            :
              <Nav variant="tabs" activeKey={location.pathname} className="nav-fill w-100 justify-content-center" style={{borderBottom: 0}}>
                <Nav.Item>
                  <Nav.Link as={NavLink} to={t('link.leave_create')} eventKey={t('link.leave_create')} style={{textDecoration: 'none', fontWeight: 'bold', color: '#11947e', borderBottom: 0}}>
                    {t('request.createLeaveTab')}
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link as={NavLink} to={t('link.requests_leave')} eventKey={t('link.requests_leave')} style={{textDecoration: 'none', fontWeight: 'bold', color: '#BBB', backgroundColor: '#f5f5f5', borderBottom: 0}}>
                    {t('request.leaveTab')}
                  </Nav.Link>
                </Nav.Item>
              </Nav>
            }
              <Stack direction="vertical" gap={3} className="w-100 p-3" style={
                user?.type === "MANAGER" ? 
                  {border: '1px solid #DDD', borderTop: 0, borderRadius: 10, backgroundColor: '#f5f5f5'} 
                : 
                  {border: '1px solid #DDD', borderTop: 0, borderRadius: 10, borderTopRightRadius: 0, backgroundColor: '#f5f5f5'}}>
              
              { requests.length === 0 && !loadingRequests ?  (
                <div style={{ textAlign: 'center', marginTop: '2rem' }}>
                    <p>{t('request.noRequest')}</p>
                </div>
              ) : (requests.map((request, index) => 
                request ? (() => {
                  // const TIMEZONE = 2; // ou récupéré dynamiquement
                  // @ts-ignore
                  // const shift = request.shift;
                  const startAt = new Date(request.startAt);
                  startAt.setHours(startAt.getHours() - TIMEZONE);

                  const stopAt = new Date(request.stopAt);
                  stopAt.setHours(stopAt.getHours() - TIMEZONE);

                  return (
                    <Stack direction="vertical" gap={3} className="w-100 pt-3">
                    
                      <div
                          className="p-3 flex-fill bg-white border rounded-4 shadow-sm hover:shadow-md transition" // can remove flex-will
                          key={`user_${request.requestId}`}
                      >
                          <Row className="g-3 align-items-center">
                            
                              {/* Avatar */}
                              <Col xs={12} md={3} lg={3} className="d-flex flex-column justify-content-center align-items-start text-center ps-3">
                                <Col className="ps-3">
                                  <Link to={`${t('link.user')}/${request.userId}`} className="text-decoration-none text-dark fw-bold link">
                                    {/* <Row> */}
                                      <UserImage user={ // @ts-ignore
                                        request.user} customClass="coworker_sm shadow-sm hover:shadow-md" key={"worker_" + request.userId} />
                                    {/* </Row> */}
                                    <Row>
                                      { // @ts-ignore
                                      truncate(request.user.username, 20)}
                                    </Row>
                                  </Link>
                                </Col>
                              </Col>
      
                              {/* Infos utilisateur */}
                              <Col className="ps-3">
                              <div className="flex-grow-1 ">
                                  {/* <p>{t('shift.title')}{ //@ts-ignore
                                  truncate(request.shift.role, 20)}</p>
                                  <p>{t('shift.location')}{ //@ts-ignore
                                  truncate(request.shift.location, 20)}</p> */}
                                  {/* <p>{t('shift.information')}{ //@ts-ignore
                                  request.shift.info}</p> */}

                                  <p style={{fontSize: 10}}>{t('shift.startAt')}{format(startAt, "EEEE d MMMM, HH:mm", {locale: getLanguage()})}</p>
                                  <p style={{fontSize: 10}}>{t('shift.stopAt')}{format(stopAt, "EEEE d MMMM, HH:mm", {locale: getLanguage()})}</p>
                                  <p>{truncate(request.description, 150)}</p>
                              </div>
                              </Col>
                              <Col className="ps-3">
                                <div className="flex-grow-1 ">
                                  <div className="flex-grow-2 text-center">
                                    {/* <IoArrowRedoCircleOutline onClick={() => goToShift(shift.shiftId)} className="hover-icon" size={80} title={t('shift.goTo')} /> */}
                                  </div>
                                  <div className="flex-grow-2 text-center">
                                  {/* {request.completed ? 
                                    // <h4 className="request_transfer">{t('request.transfered')}</h4>
                                    <MdSwapHorizontalCircle  className="hover-request-transfered" size={80} onClick={() => alreadySwaped()} title={t('request.transfer')} />
                                    :
                                    <MdSwapHorizontalCircle  className="hover-icon" size={80} onClick={() => swapShift(request)} title={t('request.transfer')} />
                                  } */}
                                  </div>
                                </div>
                              </Col>
                                {request.suggestedUser &&
                                // <Row className="d-flex justify-content-center align-items-center text-center">
                                    <>
                                    <Col className="d-flex flex-column justify-items-center text-center">
                                      { request.accepted ?
                                          <>
                                            <p style={{fontSize: 10, color: 'green'}}>{t('shift.accepted')}</p>
                                            {/* <Button className="mt-3" variant="danger" title={t('shift.delete')} onClick={() => deletedRequest(request)} >{t('shift.delete')}</Button> */}
                                          </>
                                      :
                                        (user.type === "MANAGER") &&
                                          <>
                                            <p style={{fontSize: 10, color: 'green'}}>{t('shift.notAccepted')}</p>
                                            {/*<Button variant="ccess" title={t('shift.accept')} onClick={() => acceptedRequest(request)} >{t('shift.accept')}</Button>
                                            <Button className="mt-3" variant="danger" title={t('shift.delete')} onClick={() => deletedRequest(request)} >{t('shift.delete')}</Button> */}
                                          </>
                                      }
                                    </Col>
                                  </>
                                // </Row>
                                }
                          </Row>
                      </div>
                    </Stack>
                  );
                })() : null)
            )}
          </Stack>
          <div className="pagination-container">
            {/* <p>tokenLenght: {pageTokens.length}</p>
            <p>pageIndex: {currentPageIndex}</p>
            <p>hasMorePages: {hasMorePages.toString()}</p>
            <p>currentPageIndex: {currentPageIndex}</p> */}
            <h2 className="paginationTitle">{t('title.leave_requests')}</h2>
            
            <Pagination
              currentPage={currentPageIndex}
              totalPages={totalPagination}//{hasMorePages ? pageTokens.length: pageTokens.length - 1} //{Math.ceil(pageTokens.length / 10)} // Supposons que chaque page ait 10 éléments
              hasMorePages={hasMorePages}
              onNext={handleNextPage}
              // onPrevious={() => setCurrentPageIndex(currentPageIndex - 1)}
              onPrevious={handlePreviousPage}
              onChange={handlePageChange}
              // onChange={(pageIndex) => setCurrentPageIndex(pageIndex)}
              // showFirstLast
            />
          </div>
        </div>
      </div>
    </div>
  </>
);
};

export default RequestSuggestedUserLeavesScreen;